import { Link } from 'react-router-dom';

import { Avatar } from '../ui/Avatar';
import { useAuth } from '../../store/AuthContext';
import { paths } from '../../routes/paths';
import { cn } from '../../utils/cn';

/**
 * Avatar com inicial → Definições (top bar autenticada).
 * @param {{ size?: 'sm'|'md', className?: string }} props
 */
export function ProfileAvatarLink({ size = 'sm', className }) {
  const { profile, user } = useAuth();
  const displayName =
    (profile?.full_name || '').trim().split(' ')[0] || user?.email || '';
  const initial = (displayName || '?').charAt(0).toUpperCase();

  return (
    <Link
      to={paths.settings}
      className={cn('shrink-0 transition hover:opacity-90', className)}
      aria-label="Definições"
    >
      <Avatar size={size} initials={initial} />
    </Link>
  );
}

export default ProfileAvatarLink;
